export enum ScopeSelectKeys {
  All = 'All',

  // for commercials
  WWTopOpsPartners = 'WWTopOpsPartners',
  WWTopBpsPartners = 'WWTopBpsPartners',
  MarketOpsTopPartners = 'MarketOpsTopPartners',
  MarketBpsTopPartners = 'MarketBpsTopPartners',
  Manual = 'Manual',
  ManualGlobal = 'ManualGlobal',

  // for distributors
  TopDistributors = 'TopDistributors',
}

export interface IComposedReport {
  Rank: number
  Country: string
  PartnerId: string
  PartnerName: string
  ActualPrevYear: number
  ActualCurrentYear: number
  TargetPrevYear: number
  TargetCurrentYear: number
  YoYPlan: number
  YoYTarget: number
  PMB: string
  Manager: string
  URL?: string
}

export interface IComposedReportFilters {
  EntryId: number
  Name: string
  Filters: string
  Modified: Date
}
